module.exports = __webpack_public_path__ + "static/media/map-marked-alt.2c8101f1.svg";